import api from "./api";

const get = () => {
  return api.get("/api/material/categories");
};

const create = ({ name, unit, isMandatory }) => {
  return api.post("/api/material/categories", { name, unit, isMandatory });
};

const update = (id, payload) => {
  return api.patch(`/api/material/categories/${id}`, payload);
};

// Archive/restore are a soft isActive toggle on dedicated endpoints so they can
// be gated by material:archive / material:restore separately from material:update.
const archive = (id) => {
  return api.post(`/api/material/categories/${id}/archive`);
};

const restore = (id) => {
  return api.post(`/api/material/categories/${id}/restore`);
};

const getTypes = (categoryId) => {
  const params = categoryId ? { categoryId } : undefined;
  return api.get("/api/material/types", { params });
};

const createType = ({ name, categoryId }) => {
  return api.post("/api/material/types", { name, categoryId });
};

const updateType = (id, payload) => {
  return api.patch(`/api/material/types/${id}`, payload);
};

const archiveType = (id) => {
  return api.post(`/api/material/types/${id}/archive`);
};

const restoreType = (id) => {
  return api.post(`/api/material/types/${id}/restore`);
};

const deleteType = (id) => {
  return api.delete(`/api/material/types/${id}`);
};

const MaterialService = {
  get,
  create,
  update,
  archive,
  restore,
  getTypes,
  createType,
  updateType,
  archiveType,
  restoreType,
  deleteType,
};

export default MaterialService;
